import { Box, Flex } from "@chakra-ui/react";
import Head from "next/head";
import { useUser } from "../contexts/useUser";
import { Header } from "./header";
import { Sidebar } from "./sidebar/Sidebar";

export function LayoutDocumentation({ children }) {
  const { user } = useUser();
  return (
    <>
      <Head>
        <title>ENGYS Customer Portal</title>
      </Head>
      <Box position="fixed" top="0" left="0" width="100%" zIndex="1000">
        <Header />
      </Box>
      <Box position="fixed" top="66px" left="0" height="calc(100% - 66px)" zIndex="1000">
        {typeof (user) !== 'string' &&
          <Sidebar />
        }
      </Box>
      <Box marginLeft="280px" id="documentation-id-to-styles">
        {/* <Box position="sticky" top="0" height="66px" /> */}
        {children}
      </Box>
    </>
  );
}

export function Layout({ children }) {

  const { user } = useUser();
  return (
    <>
      <Head>
        <title>ENGYS Customer Portal</title>
      </Head>
      <Header />
      <Flex style={{ minHeight: 'calc(100dvh - 66px)', height: 'calc(100dvh - 66px)' }}>
        {typeof (user) !== 'string' &&
          <Sidebar />
        }
        <Box p="0" w="100%" style={{ height: '100%', maxHeight: '100%', overflow: 'auto' }}>
          {children}
        </Box>
      </Flex>
    </>
  );
}